<template>
  <div class="cart-calculator mb-5 w-100">
    <div class="col-lg-12 col-sm-12 cart-container">
      <template v-if="successMessage === ''">
        <template v-if="!loading">
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Resumen de su pedido</span>
            <span class="badge badge-primary badge-pill">{{ cartProducts.length }}</span>
          </h4>
          <div class="row">
            <div class="col-lg-6">
              <ul class="list-group mb-3">
                <li class="list-group-item" v-for="(item, index) in cartProducts" :key="index">
                  <div class="row">
                    <template v-if="item.subproduct.id_lote == 0">
                      <div class="col-6 col-sm-4 margen-automatico" style="text-align: left;">
                        <p>
                          <strong>{{ item.name_product_es }}</strong>
                        </p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-6 col-sm-4 margen-automatico" style="text-align: left;">
                        <p>
                          <strong>{{
                            item.name_product_es + ' Lote: ' + item.subproduct.lote_sku
                          }}</strong>
                        </p>
                      </div>
                    </template>
                    <div class="col-6 col-sm-4 margen-automatico">
                      <p>
                        {{ item.price_product | currency }} X
                        <span class="span-cantidad-calculator"
                          ><strong>{{ item.qty }} </strong></span
                        >
                      </p>
                    </div>
                    <div class="col-12 col-sm-4 margen-automatico" style="text-align: left;">
                      <p>
                        <strong>{{ (item.price_product * item.qty) | currency }}*</strong>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <small>*Los precios incluyen IGV</small>
              <hr />
            </div>
            <div class="col-lg-6">
              <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between">
                  <span>Subtotal:</span> {{ (totalValue - deliveryPrice) | currency }}
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span>Despacho:</span> {{ deliveryPrice | currency }}
                </li>

                <li class="list-group-item">
                  <div class="row">
                    <div class="col-sm-4" style=" text-align: left;">
                      <span>Cupón de Descuento</span>
                    </div>
                    <div class="col-sm-8">
                      <div class="input-group mb-3">
                        <input
                          v-model="discountCode"
                          type="text"
                          class="form-control"
                          maxlength="8"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-primary"
                            @click="submitDiscountCode()"
                            type="button"
                          >
                            Enviar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li
                  v-if="discountCodeResponse !== ''"
                  :class="{'text-danger':isErrorResponse, 'text-success':!isErrorResponse}"
                  class="list-group-item d-flex justify-content-between"
                >
                  <strong>{{ discountCodeResponse }}</strong>
                </li>
                <li v-if="isDiscountApplied" class="list-group-item d-flex justify-content-between">
                  <span><strong>Descuento:</strong></span>
                  <strong>{{discountPercent}}%</strong>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span><strong>Total:</strong></span>
                  <strong>{{ totalValue | currency }}</strong>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span>Tipo de Comprobante</span>
                  <strong
                    ><select v-model="tipoCDP" name="" id="" class="form-control">
                      <option value="0">Seleccione</option>
                      <option value="1">Boleta</option>
                      <option value="2">Factura</option>
                    </select>
                  </strong>
                </li>
                <template v-if="tipoCDP == 2">
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-sm-2" style=" text-align: left;"><span>RUC</span></div>
                      <div class="col-sm-10">
                        <strong><input v-model="ruc" maxlength="11" class="form-control"/></strong>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-sm-2" style=" text-align: left;">
                        <span>Razón Social</span>
                      </div>
                      <div class="col-sm-10">
                        <strong
                          ><input v-model="razsoc" type="text" maxlength="300" class="form-control"
                        /></strong>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-sm-2" style=" text-align: left;">
                        <span>Dirección Fiscal</span>
                      </div>
                      <div class="col-sm-10">
                        <strong
                          ><input v-model="facdir" type="text" maxlength="300" class="form-control"
                        /></strong>
                      </div>
                    </div>
                  </li>
                </template>
                <iframe name="dummyframe" id="dummyframe" style="display: none;"></iframe>
                <li class="list-group-item d-flex justify-content-between">
                  <small>
                    <strong>
                      <input type="checkbox" id="checkbox" v-model="checked" /> He leido y estoy de
                      acuerdo con las
                      <router-link to="/guia/7" target="_blank">Términos y Condiciones</router-link>
                      de Armaq.
                    </strong>
                  </small>
                </li>
                <template v-if="cartProducts.length > 0">
                  <template v-if="isEnabledSale == true">
                    <template v-if="isEnabledTpv == true">
                      <NiubizPaymentButton
                        :configData="configData"
                        :checked="checked"
                        :tipoCDP="tipoCDP"
                        :ruc="ruc"
                        :razsoc="razsoc"
                        :facdir="facdir"
                        :loggedUserData="loggedUserData"
                        :totalValue="totalValue"
                      />
                      <NiubizPagoLinkPaymentButton
                        :configData="configData"
                        :checked="checked"
                        :tipoCDP="tipoCDP"
                        :ruc="ruc"
                        :razsoc="razsoc"
                        :facdir="facdir"
                        :loggedUserData="loggedUserData"
                        :totalValue="totalValue"
                        :cartProducts="cartProducts"
                      />
                      <CashPaymentButton
                        :configData="configData"
                        :checked="checked"
                        :tipoCDP="tipoCDP"
                        :ruc="ruc"
                        :razsoc="razsoc"
                        :facdir="facdir"
                        :loggedUserData="loggedUserData"
                        :totalValue="totalValue"
                        :cartProducts="cartProducts"
                        :arrayOfAvailableBanksToPay="arrayOfAvailableBanksToPay"
                      />
                    </template>
                  </template>
                  <template v-else>
                    <small style="color:#dc3545;"
                      >Uno o varios de los productos seleccioandos no se encuentran habilitados para
                      el pedido o venta online. Agrege solamente productos habilitados.</small
                    >
                  </template>
                </template>
              </ul>
            </div>
          </div>
        </template>
        <template v-else-if="loading">
          <li class="list-group-item">
            <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
            <p>Estamos procesando su compra. Por favor, espere.</p>
          </li>
        </template>
      </template>
      <div :class="[successMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
        <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
          &times;</button
        ><strong>{{ successMessage }}<router-link to="/pedidos">aquí</router-link>.</strong>
      </div>
      <div :class="[errorMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
        <button type="button" class="close" data-dismiss="alert" @click="hideMessages()">
          &times;</button
        ><strong><span v-html="errorMessage"></span></strong>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import { config_settings } from '@/config.js';
import { UNAUTHORIZED, BAD_GATEWAY } from '@/types/httpd.constants';
import {
  generateRefreshTokenBodyRequest,
  getAccessToken,
  deleteCartItems,
  setTokens,
} from '@/helpers/localStorage.helpers';
import { postLogin, postNewAccountToErp, getProfileData } from '@/service/account.service';
import { getPaymentMethods, evaluateCouponsCode } from '@/service/process.service';
import NiubizPaymentButton from '@/components/products/cart/CartProductsStepThree/components/NiubizPaymentButton.vue';
import NiubizPagoLinkPaymentButton from '@/components/products/cart/CartProductsStepThree/components/NiubizPagoLinkPaymentButton.vue';
import CashPaymentButton from '@/components/products/cart/CartProductsStepThree/components/CashPaymentButton.vue';

export default {
  name: 'CartCalculatorWebPayment',
  components: { NiubizPaymentButton, NiubizPagoLinkPaymentButton, CashPaymentButton },
  props: ['configData'],
  data() {
    return {
      isProdEnviorment: config_settings.PROD_ENV,
      checked: false,
      loggedUserData: null,
      loading: false,
      totalValue: 0.0,
      isEnabledSale: true,
      isEnabledTpv: true,
      tipoCDP: '0',
      razsoc: '',
      ruc: '',
      facdir: '',
      discountCode: '',
      discountCodeResponse: '',
      discountPercent: 0, 
      isErrorResponse: false,
      isDiscountApplied: false, 
      successMessage: '',
      errorMessage: '',
      arrayOfAvailableBanksToPay: [],
      deliveryPrice: JSON.parse(localStorage.getItem('price_delivery')),
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    ...mapMutations(['SET_CART_PRODUCTS']),

    setLoadingValue(value) {
      this.loading = value;
    },

    setSucessMessage(successMessage) {
      this.successMessage = successMessage;
      this.errorMessage = '';
    },

    setErrorMessage(errorMessage) {
      this.errorMessage = errorMessage;
      this.successMessage = '';
    },

    hideMessages() {
      this.successMessage = '';
      this.errorMessage = '';
    },

    submitDiscountCode() {
      const discountCode = this.discountCode;
      
      evaluateCouponsCode(discountCode)
        .then((response) => {
          this.discountCodeResponse = `Código de descuento ${response.data.promo_code} aplicado exitosamente.`;
          this.discountPercent = response.data.discount_percent;
          this.isErrorResponse = false;
          this. isDiscountApplied = true; 
          this.calculateTotal();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.submitDiscountCode();
              })
              .catch((_) => {});
          } else {
            this.discountCodeResponse = `Código de descuento ingresado no es valido.`;
            this.discountPercent = 0;
            this.isErrorResponse = true;
            this.isDiscountApplied = false;
            this.calculateTotal();
          }
        });
    },

    analizeCart() {
      let totalValue = 0.0;
      this.isEnabledSale = true;
      this.cartProducts.forEach((product, index) => {
        if (product.allowed_sale == false) {
          this.isEnabledSale = false;
        }
        if (product.allowed_tpv == false) {
          this.isEnabledTpv = false;
        }
        var subtotalPerProduct = (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotalPerProduct = Math.round(subtotalPerProduct) / 100.0;
        totalValue = totalValue + subtotalPerProduct;
      });
      this.totalValue = Math.round((totalValue + this.deliveryPrice) * 100) / 100;
    },

    calculateTotal() {
  let subtotal = this.cartProducts.reduce((sum, item) => {
    return sum + (item.price_product * item.qty);
  }, 0);

  const discountValue = (subtotal * this.discountPercent) / 100;
  const discountedSubtotal = subtotal - discountValue;
  this.totalValue = discountedSubtotal + this.deliveryPrice;
},


    createAccountForErp(userData) {
      postNewAccountToErp(userData)
        .then((response) => {
          console.log('Usuario registrado correctamente en ERP!');
        })
        .catch((error) => {
          this.errorMessage = 'ATENCIÓN: Se presentó un error en el envio de información al ERP.';
        });
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    getUserData() {
      getProfileData(getAccessToken())
        .then((response) => {
          this.loggedUserData = response.data;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.getUserData();
              })
              .catch((_) => {});
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    removeAllProductCart() {
      var products = [];
      this.SET_CART_PRODUCTS(products);
      deleteCartItems();
      this.analizeCart();
    },

    getBanksAvailableToPay() {
      getPaymentMethods(getAccessToken())
        .then((response) => {
          this.arrayOfAvailableBanksToPay = response.data;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.getBanksAvailableToPay();
              })
              .catch((_) => {
                console.log('Error de authorization');
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },
  },
  created() {
    this.getBanksAvailableToPay();
    this.analizeCart();
    this.getUserData();
  },
};
</script>
